import React from 'react'

const Poster: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/poster.svg" alt="poster"/>
  )
}

export default Poster